import { render, staticRenderFns } from "./MyProjectsWatchlist.vue?vue&type=template&id=2d627ba9&scoped=true"
import script from "./MyProjectsWatchlist.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyProjectsWatchlist.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MyProjectsWatchlist.vue?vue&type=style&index=0&id=2d627ba9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d627ba9",
  null
  
)

export default component.exports